import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideFuse } from '@fuse';
import { appRoutes } from 'app/app.routes';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { provideTransloco } from 'app/core/transloco/transloco.provider';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),

        // Messaggi a comparsa e finestre di dialogo usati da NotifyService e dalle liste
        importProvidersFrom(MatSnackBarModule, MatDialogModule),
        provideRouter(appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
        ),

        // Italiano
        {provide: LOCALE_ID, useValue: 'it'},
        {provide: MAT_DATE_LOCALE, useValue: 'it-IT'},

        // Material Date Adapter
        {
            provide : DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide : MAT_DATE_FORMATS,
            useValue: {
                parse  : {
                    dateInput: 'dd/MM/yyyy',
                },
                display: {
                    dateInput         : 'dd/MM/yyyy',
                    monthYearLabel    : 'LLL yyyy',
                    dateA11yLabel     : 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        // Transloco Config
        provideTransloco(),

        // Fuse (accesso con token JWT; il client HTTP è configurato in provideAuth)
        provideAuth(),
        provideIcons(),
        provideFuse({
            fuse: {
                layout : 'classy',
                scheme : 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme  : 'theme-default',
                themes : [
                    {
                        id  : 'theme-default',
                        name: 'StayInPuglia',
                    },
                ],
            },
        }),

        // Campi dei moduli: lo spazio sotto al campo si adatta ai suggerimenti (va dichiarato dopo provideFuse, che imposta i propri valori)
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'fill', subscriptSizing: 'dynamic'}},
    ],
};
